import { ActionIcon, Tooltip } from '@mantine/core';
import { variants } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

const isLargeScreen = window.screen.width >= 1920;

export const ViewModeToggle = () => {
    const { t } = useTranslation();
    const { isViewMode, setIsViewMode } = usePlacementStore(
        useShallow((state) => ({ isViewMode: state.isViewMode, setIsViewMode: state.setIsViewMode }))
    );

    return (
        <Tooltip
            label={isViewMode ? t('buttonDisableViewMode') : t('buttonEnableViewMode')}
            position="right"
            variant={variants.tooltip.right}
        >
            <ActionIcon
                className={`${isViewMode ? '' : 'bg-background-gray-ultra-light hover:bg-background-gray!'} ${
                    isLargeScreen ? 'action-icon-large' : 'action-icon-medium'
                }`}
                variant={isViewMode ? variants.actionIcon.activated : undefined}
                onClick={() => setIsViewMode(!isViewMode)}
            >
                visibility
            </ActionIcon>
        </Tooltip>
    );
};
